import { Redirect, Route, RouteProps } from "react-router";
import * as routePath from "shared/constants/RoutePathConstants";

export type PublicRouteProps = {
  path: string;
  isUserLoggedIn: boolean;
  restricted?: boolean;
  homePagePath?: string;
} & RouteProps;

export default function PublicRoute(routProps: PublicRouteProps) {
  const { path, component, isUserLoggedIn, restricted, homePagePath, ...rest } =
    routProps;

  return (
    <Route
      {...rest}
      render={(props) =>
        isUserLoggedIn && restricted ? (
          <Redirect to={homePagePath || ""} />
        ) : (
          <Route {...routProps} />
        )
      }
    />
  );
}

PublicRoute.defaultProps = {
  homePagePath: routePath.GET_STARTED,
};
